"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _card = _interopRequireWildcard(require("@pds-react/card"));

var _icon = _interopRequireDefault(require("@pds-react/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "variant", "dismissable", "role", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Alerts help provide feedback to the user about the state of their interaction within a page or application. */
var Alert = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      variant = props.variant,
      dismissable = props.dismissable,
      role = props.role,
      className = props.className,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = (0, _classnames["default"])(className, "pds-alert", "pds-alert-".concat(variant), {
    "pds-alert-dismissible": dismissable
  });
  var iconName = {
    information: "alert-circle",
    error: "alert-triangle",
    warning: "alert-triangle",
    success: "check",
    banner: "alert-circle"
  }[variant]; // when the alert has been dismissed, don't render it

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dismissed = _React$useState2[0],
      setDismissed = _React$useState2[1];

  if (dismissed) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_card["default"], _extends({
    className: classes,
    ref: ref
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_card.CardSection, null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: iconName,
    className: "pds-alert-type-icon"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-alert-content",
    role: role
  }, children), dismissable && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "pds-alert-close",
    "aria-label": "Close",
    onClick: function onClick() {
      return setDismissed(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: "x"
  }))));
});

Alert.propTypes = {
  /** Controls the accent color and icon of the alert. */
  variant: _propTypes["default"].oneOf(["information", "error", "warning", "success", "banner"]).isRequired,

  /**
   * The standard `role` attribute.
   * It can be set to "alert" when the Alert should interupt a screen reader user
   * and be announced immediately.
   */
  role: _propTypes["default"].oneOf(["alert"]),

  /** Adds an "x" that allows the Alert to be dismissed. */
  dismissable: _propTypes["default"].bool,

  /** Changes the HTML element of the Alert. (This would be rare.) */
  as: _propTypes["default"].elementType,

  /** Extra classes for the Alert. */
  className: _propTypes["default"].string,

  /** The content of the Alert. */
  children: _propTypes["default"].node.isRequired
};
Alert.displayName = "Alert";
Alert.defaultProps = {
  as: "div"
};
var _default = Alert;
exports["default"] = _default;